<!--
 * @Author: HWD
 * @Date: 2021-11-04 11:39:04
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-16 17:28:30
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
-->
<template>
    <el-carousel :interval="window.interval" arrow="always">
      <template v-if="window.showState">
        <el-carousel-item v-for="(item, index) in window.ad_path" :key="index">
          <img :src="item.ad_path" />
        </el-carousel-item>
      </template>
    </el-carousel>
</template>
<script>
import Fetch from "../utils/fetch";
export default {
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      window:{
        interval:5000,
        showState:true,
        ad_path: [],
        adpic: [
          {
            img: "https://img-s-msn-com.akamaized.net/tenant/amp/entityid/AAQ20cO.img?h=412&w=624&m=6&q=60&o=f&l=f&x=408&y=143",
          },
          {
            img: "https://x0.ifengimg.com/ucms/2021_44/F7B09660AB87809070A5D186D796F3E105D8C133_size421_w1080_h602.png",
          },
        ],
        source:''
      },
   
    };
  },
  created() {
    this.getData()
  },
  methods:{
      async getData() {
      //const data = await Fetch("getAdInfo.php", { CarId: this.source });
      const data = await Fetch("getAdInfo.php", {CarId: this.source});
      console.log(data);
      if (data.code == 200) {
        this.window.interval = data.data.interval;
        this.window.showState = data.data.showState;
        this.window.ad_path = data.data.ad_path;
        
      }
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.el-carousel__container {
  height: 10.5rem !important;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 10.5rem !important;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__arrow--left,
.el-carousel__arrow--right {
  display: none;
}

.el-carousel .el-carousel__container .el-carousel__item img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: auto;
  zoom:1;
}
</style>